import { useEffect } from 'react';
import { getDateRange, isSameDay } from '../../utils/format-timezone';
import { DataStatus } from '../../appointment-state';
import { useFieldActions } from '../../../../contexts/field-actions-context';
import { useAppointmentContext } from '../../context/appointment-context';
export const useSlotSelectedFromTP = _ref => {
  let {
    setIsReloadingSlots
  } = _ref;
  const {
    appointmentFieldProps,
    appointmentState,
    setAppointmentState
  } = useAppointmentContext();
  const {
    value: selectedSlot
  } = appointmentFieldProps;
  const {
    actions
  } = useFieldActions();
  useEffect(() => {
    const slotSelectedByOutSource = async () => {
      // When out source select slot from another day ( for example velo user)
      if (selectedSlot != null && selectedSlot.startDate && appointmentState != null && appointmentState.selectedDate && (appointmentState == null ? void 0 : appointmentState.dataStatus) === DataStatus.DONE) {
        const sameDate = isSameDay(new Date(selectedSlot.startDate), appointmentState == null ? void 0 : appointmentState.selectedDate);
        if (!sameDate) {
          setIsReloadingSlots(true);
          const selectedDate = new Date(selectedSlot.startDate);
          const {
            fromDate,
            toDate
          } = getDateRange(selectedDate, 8);
          const [availabilityDatesToUpdate, availabilitySlotsToUpdate] = await Promise.all([actions == null || actions.getAvailabilityDates == null ? void 0 : actions.getAvailabilityDates({
            serviceId: appointmentFieldProps == null ? void 0 : appointmentFieldProps.initialData.service.id,
            timeZone: (appointmentState == null ? void 0 : appointmentState.timezone) || '',
            fromDate,
            toDate
          }), actions == null || actions.getAvailabilitySlots == null ? void 0 : actions.getAvailabilitySlots({
            serviceId: appointmentFieldProps == null ? void 0 : appointmentFieldProps.initialData.service.id,
            timeZone: (appointmentState == null ? void 0 : appointmentState.timezone) || '',
            selectedDate
          })]);
          setAppointmentState({
            availabilityDates: availabilityDatesToUpdate,
            selectedDate,
            availabilitySlots: availabilitySlotsToUpdate
          });
          setIsReloadingSlots(false);
        }
      }
    };
    slotSelectedByOutSource();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSlot, appointmentState == null ? void 0 : appointmentState.dataStatus]);
};
//# sourceMappingURL=index.js.map